import React from 'react';
import logo from '../assets/images/logo.png';
import { Link } from 'react-router-dom';
import maintenanceImg from '../assets/images/page-loader.gif'; // Using an existing image or fallback

const UnderMaintenance = () => {
  return (
    <div className="container-fluid vh-100 d-flex flex-column justify-content-center align-items-center bg-light">
      <div className="text-center p-5 bg-white rounded-4 shadow-sm" style={{ maxWidth: '600px', width: '90%' }}>
        <img 
          src={logo} 
          alt="Wingstop Logo" 
          className="img-fluid mb-4" 
          style={{ height: '80px', objectFit: 'contain' }}
        />
        <div className="mb-4">
           {/* Placeholder for maintenance image if needed, or just use the loader/logo */}
           <i className="bi bi-gear-wide-connected text-secondary" style={{ fontSize: '5rem' }}></i>
        </div>
        <h2 className="fw-bold mb-3 text-dark">Under Maintenance</h2>
        <p className="text-muted fs-5 mb-0">
          Our services are currently under maintenance. <br/>
          Please check back later.
        </p>
        <Link to="/" className="btn btn-base mt-4">Refresh <i className="bi bi-arrow-repeat"></i> </Link>
      </div>
    </div>
  );
};

export default UnderMaintenance;
